import { render, staticRenderFns } from "./TheSendTransactionLayout.vue?vue&type=template&id=076389a2&"
import script from "./TheSendTransactionLayout.vue?vue&type=script&lang=js&"
export * from "./TheSendTransactionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports